import { render, staticRenderFns } from "./InstallmentFormPedestalView.vue?vue&type=template&id=66f89a5a&"
import script from "./InstallmentFormPedestalView.vue?vue&type=script&lang=js&"
export * from "./InstallmentFormPedestalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports